import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

export interface IClearableValueCellRendererParams<RowType = any> extends ICellRendererParams<RowType> {
  isClearable?: (data: RowType) => boolean;
  onClear: (data: RowType) => void;
}

@Component({
  standalone: true,
  selector: 'dw-grid-clearable-value-cell',
  template: `
    <div class="dw-grid-clearable-value-cell">
      <span class="dw-grid-clearable-value-cell__value">{{ value }}</span>
      @if (clearable) {
        <i class="digi-out-cross dw-grid-clearable-value-cell__clear" (click)="clear($event)"></i>
      }
    </div>
  `,
  styles: [
    `
      .dw-grid-clearable-value-cell {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        width: 100%;
        height: 100%;
      }

      .dw-grid-clearable-value-cell__value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .dw-grid-clearable-value-cell__clear {
        cursor: pointer;
        flex: none;
        font-size: 0.65rem;
        color: var(--bs-gray-600);
      }

      .dw-grid-clearable-value-cell__clear:hover {
        color: var(--bs-danger);
      }
    `,
  ],
})
export class ClearableValueRendererComponent<RowType = any> implements ICellRendererAngularComp {
  protected value = '';
  protected clearable = false;

  private params: IClearableValueCellRendererParams<RowType>;

  agInit(params: IClearableValueCellRendererParams<RowType>): void {
    this.setParams(params);
  }

  refresh(params: IClearableValueCellRendererParams<RowType>): boolean {
    this.setParams(params);
    return true;
  }

  protected clear(event: MouseEvent): void {
    event.stopPropagation();
    this.params.onClear(this.params.data);
  }

  private setParams(params: IClearableValueCellRendererParams<RowType>): void {
    this.params = params;
    this.value = params.valueFormatted ?? params.value ?? '';
    this.clearable = params.isClearable?.(params.data) ?? false;
  }
}
